{
  "decrease": "Riduci {fieldLabel}",
  "increase": "Aumenta {fieldLabel}",
  "numberField": "Campo numero"
}
